<template>
  <v-container :style="{ padding: '0px' }">
      <v-row align="center" class="gap-sm">
        <span class="text-caption">{{ $t('lds.useValues') }}</span>
        <v-switch dense @change="$emit('TOGGLE_PERCENT_MODE')" :input-value="isPercentMode"></v-switch>
        <span class="text-caption">{{ $t('lds.usePercent') }}</span>
      </v-row>
      <v-row>
        <v-col cols="6" >
          <VfCurrencyInput
            v-if="!isPercentMode"
            v-model="centsValue"
            :currency="{ ...selectedCurrency, value: 1 }"
            :currencies="contractCurrencies"
            :label="$t('lds.overallCap')"
            :error-messages="errorsCents"
            outlined
          />
          <VfPercentageInput
            v-if="isPercentMode"
            v-model="percentValue"
            :label="$t('lds.overallCap')"
            :error-messages="errorsPercent"
            outlined
            />
        </v-col>
        <v-col cols="3" v-if="currencies.length > 1 && !isPercentMode">
          <v-autocomplete
            v-model="currencyValue"
            :items="currencies"
            :label="$t('contract.currencyCode')"
            outlined
          />
        </v-col>
        <slot></slot>
      </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'LiquidatedDamagesCapForm',
  props: {
    contractCurrencies: Array,
    parts: Array,
    valueCents: Number,
    valuePercent: Number,
    currency: String,
    errorsCents: {
      type: Array,
      default: () => []
    },
    errorsPercent:
    {
      type: Array,
      default: () => []
    },
    isPercentMode: Boolean
  },
  computed: {
    selectedCurrency () {
      return this.contractCurrencies.find(i => i.key === this.currency)
    },
    currencies () {
      return this.parts ? this.parts.map(item => item.currency) : this.contractCurrencies
    },
    centsValue: {
      get () {
        return this.valueCents
      },
      set (value) {
        this.$emit('CENTS_INPUT', value)
      }
    },
    percentValue: {
      get () {
        return this.valuePercent
      },
      set (value) {
        this.$emit('PERCENT_INPUT', value)
      }
    },
    currencyValue: {
      get () {
        return this.currency
      },
      set (value) {
        this.$emit('CURRENCY_INPUT', value)
      }
    }
  }
}
</script>
